import { logger } from '@automata/utils';
import { Action, Argument } from '@automata/wfb-api/src/apis/wfbApiSchemas';

import { InstrumentForLocation } from '../../types';

export const getDriverArguments = (
  driverAction: Action | null,
  instrument: InstrumentForLocation | null,
  isSingleLabwareTask: boolean,
  taskType?: string
): { [key: string]: Argument } | null => {
  if (driverAction === null) return null;
  if (driverAction.is_sub_action) return null;

  const hasSlotStartAndEndArguments =
    Object.prototype.hasOwnProperty.call(
      driverAction.arguments,
      'slot_start'
    ) &&
    Object.prototype.hasOwnProperty.call(driverAction.arguments, 'slot_end');
  const shouldUseSlotRangeForReadBarcode =
    taskType === 'read_barcode' && hasSlotStartAndEndArguments;

  // NOTE(LT, 20/12/2024): this will overwrite the slot argument if it already exists
  const shouldAddSlotArgument =
    instrument &&
    instrument.capacity > 1 &&
    !instrument.is_slotless_container &&
    (isSingleLabwareTask || shouldUseSlotRangeForReadBarcode);

  if (shouldAddSlotArgument) {
    const slotArgument: Argument = {
      type: 'str',
      units: null,
      default: 'NO_DEFAULT',
      is_deprecated: false,
      min_value: null,
      max_value: null,
      is_required: true,
    };

    const actionArguments = shouldUseSlotRangeForReadBarcode
      ? Object.fromEntries(
          Object.entries(driverAction.arguments).filter(
            ([name]) => name !== 'slot_start' && name !== 'slot_end'
          )
        )
      : driverAction.arguments;

    return {
      ...actionArguments,
      slot: slotArgument,
    };
  }

  return driverAction.arguments;
};

export const getInstrument = (
  instrumentId: string | null,
  instrumentsById: Record<string, InstrumentForLocation>
): InstrumentForLocation | null => {
  if (instrumentId === null) {
    logger.error('no instrument', instrumentId);
    return null;
  }

  const instrument = instrumentsById[instrumentId];
  if (instrument === undefined) {
    logger.error('no instrument', instrumentId);
    return null;
  }

  return instrument;
};
